// extracted by mini-css-extract-plugin
export default {"image":"dX-z","loaded":"eX-z"};